export const APP_ROUTES = {
  HOME_RECEPTION: 'home/reception',
  HOME_TECHNICAL: 'home/technical',
  HOME_ADMIN: 'home/admin',
  LOGIN: 'auth/login',
  CHANGE_PASSWORD: 'auth/change-password',
  NOT_FOUND: 'not-found',
  ADMIN_ORDER_HISTORY: '/admin/order-history',
  ADMIN_CUSTOMERS: 'admin/customers',
  ADMIN_QUOTES: 'operations/quotes',
} as const;
